(function ($) {
    /**
     * jQuery plugin used to handle ajax-requests bound to specific form content
     * @param options
     * @returns {jQuery}
     */
    $.fn.globalForm = function (options) {
        var form = this;

        this.formHandler = new FormHandler(form, options);

        return this;
    };

    function FormHandler(form, options) {
        this.form = $(form);
        this.init(form, options);
    }

    FormHandler.prototype = {
        form: null,
        params: {},
        defaultParams: {
            hideFormAfterRequest: true,
            data: {

            },
            selectors: {

            },
            templates: {

            }
        },

        extend: function(destination, source){
            for (var property in source) {
                destination[property] = source[property];
            }
            return destination;
        },

        init: function (form, options) {
            var self = this;

            self.params = JSON.parse(JSON.stringify(self.defaultParams));
            self.extend(self.params, options);

            console.log('Applying globalForm plugin for form');

            self.addFormHandler();
        },

        addFormHandler: function () {
            var self = this,
                form = self.form;

            form.on('submit', function (e) {
                e.preventDefault();
                var request = form.serialize(),
                    method = form.attr('method'),
                    url = form.attr('action') ? form.attr('action') : '/';

                form.dimmer('toggle');

                jQuery.ajax({
                    url: url,
                    type: method,
                    data: request,
                    success: self.showMessage,
                    error: self.failedResponse,
                    context : self
                });
            })
        },

        showMessage : function (data, textStatus, jqXHR) {
            if (typeof data == "string")
                data = JSON.parse(data);

            var self = this,
                form = self.form,
                responseIsPositive = data.result == true,
                //messageBoxSelector = responseIsPositive ?  '.ui.info.message' : '.ui.negative.message',
                $positiveMessageBox = $(form.parent().find('.ui.info.message')),
                $negativeMessageBox = $(form.parent().find('.ui.negative.message')),
                $messageBox = responseIsPositive ?  $positiveMessageBox : $negativeMessageBox,
                $header = $($messageBox.find('.header')),
                $text = $($messageBox.find('.text')),
                headerText, contentText;

            //редиректим, если указано
            if (data.redirect)
                window.location.replace(data.redirect);

            //если ответ сервера позитивный
            if (responseIsPositive){
                headerText = data.uiSuccessMessage.header;      //печатаем заголовок
                contentText = data.uiSuccessMessage.content;    //и тело
                $negativeMessageBox.hide();                     //скрываем блок с ошибкой
                form.hide();                                    //форму тоже
            } else {
                headerText = 'Извините, произошла ошибка';      //в противном случае печатаем заголовок ошибки
                headerText = '';      //в противном случае печатаем заголовок ошибки
                contentText = data.message;                     //и тело ошибки
            }

            form.dimmer('toggle');  //лоадер убираем

            $messageBox.show();         //показываем контент
            $header.text(headerText);
            $text.text(contentText);
        },
        
        failedResponse: function (jqXHR, textStatus, errorThrown) {
            this.showMessage({
                result: false,
                message: 'Возникла ошибка при обращении к серверу. Повторите попытку позже'
            })
        }
    };

    //default form handling application by class name
    $('.global-form').each(function (i, el) {
        $(el).globalForm();
    });

})(jQuery);



// WEBPACK FOOTER //
// ./assets/javascript/formsHandler.js